export const environment = {
  production: false,
  url: "https://qa-backend.mrh360beneficios.com.br/api",
  paginationSquad: {
    totalPerPage: 10,
  },
  timeSheetManagement: {
    url: "https://cdn-endpoint-meurhm-pnt-hm-d0gtg4d0bde9fcgt.z01.azurefd.net/api/v1",
    urlv2:
      "https://cdn-endpoint-meurhm-pnt-hm-d0gtg4d0bde9fcgt.z01.azurefd.net/api/v2",
  },
  maxShowItemsPopover: 4,
  maxShowItemsList: 1,
  verboseComponent: {
    popoverListComponent: false,
    showListComponent: false,
    componentSquadTabs: false,
  },
  inactivityTimeout: 15 * 60 * 1000, // 15 minutos em milissegundos
};
